module.exports = __webpack_public_path__ + "img/food-38.e47f1ea8.jpg";